import { startCase } from "lodash";
import { DateTime } from "luxon";
import React from "react";

import { ChipStatus, IgChip, IgTooltip } from "@intelligems/ig-theme";
import { capitalizeFirstLetter } from "@intelligems/ig-utils";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { Grid } from "@mui/material";

import { useGetTestSchedules } from "../../../../../../api/schedules/get-schedules-by-experience-id";
import { ExperienceFe } from "../../../../../../types/schemas/experiences";

interface StatusRendererProps {
  experience: ExperienceFe;
}

const Colors: Record<string, ChipStatus> = {
  pending: "info",
  started: "success",
  paused: "warning",
  ended: "error",
};

export const StatusRenderer = ({ experience }: StatusRendererProps) => {
  const schedule = useGetTestSchedules(experience.id!);

  const color = Colors[experience.status!];

  if (schedule.isSuccess && schedule.data.schedules.length) {
    return (
      <IgTooltip
        title={
          <Grid container direction={"column"}>
            <Grid item sx={{ textAlign: "center" }}>
              Schedules:
            </Grid>
            {schedule.data.schedules.map((schedule) => (
              <Grid item key={schedule.id}>
                {startCase(schedule.action)}:{" "}
                {DateTime.fromMillis(schedule.executionTime).toLocaleString(
                  DateTime.DATETIME_SHORT
                )}
              </Grid>
            ))}
          </Grid>
        }
      >
        <IgChip
          status={color}
          label={
            <Grid
              container
              columnSpacing={1}
              alignItems={"center"}
              flexWrap={"nowrap"}
            >
              <Grid item>{capitalizeFirstLetter(experience.status)}</Grid>
              <Grid item sx={{ marginTop: "4px" }}>
                <ScheduleIcon sx={{ fontSize: "14px" }} />
              </Grid>
            </Grid>
          }
        />
      </IgTooltip>
    );
  }

  return (
    <IgChip status={color} label={capitalizeFirstLetter(experience.status)} />
  );
};
